import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { UserService, NotificationService, SuperAdminClientTab, CONSTANTS } from '@conpulse-web/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'conpulse-web-account-and-billing',
  templateUrl: './account-and-billing.component.html',
  styleUrls: ['./account-and-billing.component.scss']
})
export class AccountAndBillingComponent implements OnInit {
  isLoading: boolean = false;
  routerSubscription: Subscription | null = null;
  currentUrl: string = '';
  isFirm = false

  constructor(private route: ActivatedRoute, private userService: UserService, private notificationService: NotificationService, private router: Router) {
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && event.url) {
        this.currentUrl = event.urlAfterRedirects
      }
    });
  }

  ngOnInit(): void {
    this.isFirm = CONSTANTS.CF_PROFILE_ROLES.includes(this.userService.currentUserInformation?.role)
  }

}
